import { HttpErrorResponse,  HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError,  throwError } from 'rxjs';
import { SessionService } from '../common/session.service';
import { Router } from '@angular/router';


const ignoreUrl= ['/payments/process',
  '/payments/receipts/','/authentication/login','/schools/bills/student'];
export const authInterceptor: HttpInterceptorFn = (req, next) => {


  const authService = inject(SessionService);
  const router = inject(Router);

  let free =req.url.indexOf('public')>=0;
  console.log('free url :',free,req.url);
     for( let ul of ignoreUrl){
   
      if(req.url.indexOf(ul)>=0){
        console.log(req.url);
        console.log(ul);
        free =true;
        break;
      }
     }
  if(!free){
  let token = authService.getToken();
  if( token!=null&&token.length>0){
  req = req.clone({
    setHeaders: {
      Authorization: 'Bearer '+ token
    }
  });
}else {
  console.log('token is null');

}
}
  return next(req).pipe(
    catchError((err: any) => {
    if( err instanceof HttpErrorResponse) {
        if(err.status==HttpStatusCode.Forbidden||err.status==HttpStatusCode.Unauthorized){
          if(!free){
          router.navigate(['login']);
          }
    }
  }
    return throwError(() => err); 
  })
);
}